module.exports = __webpack_public_path__ + "img/trunk_4x3_z18.46e088a9.svg";